import styled from "@emotion/styled";

export const Tabs = styled.div`
  margin-left: 240px;

  @media (max-width: 440px) {
    margin-left: 0;
  }

  .tournament-info-wrapper {
    display: flex;
    column-gap: 1rem;

    > div {
      border-radius: 5px;
      padding: 10px;
      margin-top: 30px;
      width: 50%;
      > div {
        background-color: #1d2029;
        padding: 0.625rem;
      }
    }

    @media (max-width: 858px) {
      flex-direction: column;
      
      > div {
        margin: auto;
        height: fit-content;
        width: 100%;
        max-width: 100%;
      }
    }
  }

  .tournament-reg-wrapper {
    padding: 0 1rem;
    h2 {
      margin-left: 0;
    }

    > ul {
      margin-bottom: 2rem;

      b {
        font-size: 1.325rem;
      }
    }
  }
`;

export default styled.div`
  /* Profile Info */
  .game_info_pic img {
    position: absolute;
    top: 150px;
    left: 250px;
    width: 170px;
    height: 230px;
    border-radius: 5px;
  }

  .container2 {
    display: block;
    margin-top: 20px;
    margin-left: 200px;
    height: 320px;
  }

  .ph1 {
    position: absolute;
    margin-left: 240px;
    margin-top: 55px;
    font-size: 40px;
    font-weight: bolder;
  }

  .phases {
    border: 1px;
    border-style: solid;
    border-color: #7d7d7d;
    padding: 4px;
    border-radius: 20px;
    width: 180px;
    margin-top: 10px;
    margin-left: 10px;
  }

  .phases2 {
    border: 1px;
    border-style: solid;
    border-color: #7d7d7d;
    padding: 4px;
    border-radius: 20px;
    width: 180px;
    margin-top: -173px;
    margin-left: 255px;
  }

  .phases3 {
    border: 1px;
    border-style: solid;
    border-color: #7d7d7d;
    padding: 4px;
    border-radius: 20px;
    width: 180px;
    margin-top: -178px;
    margin-left: 495px;
  }

  .reg_icon img {
    margin-top: 20px;
    margin-left: 60px;
  }

  .reg_icon p {
    margin-left: -480px;
  }
  /* Floating Navbar */

  .tourn_float_navbar {
    background-color: #1d2029;
    border-radius: 50px;
    column-gap: 1rem;
    display: flex;
    height: 40px;
    justify-content: space-around;
    overflow: hidden;
    padding: 0 2rem;
    position: relative;
    margin-left: 240px;

    button {
      background: none;
      border: 0;
      cursor: pointer;
      position: relative;
      color: #7d7d7d;
      text-decoration: none;
      font-weight: 600;

      &:hover {
        color: #ffffff;
      }

      &.active {
        color: #ffff;
      }
    }
  }

  /* Info Section */
  .tourn_column {
    max-width: 45%;
  }
  .tourn_container {
    @media only screen and (max-device-width: 480px) {
      max-width: 100%;
      margin-left: -1.3em;
      margin: auto;
      margin-left: 3%;
      margin-left: 0;
    }
  }

  .tourn_container p {
    text-align: center;
  }

  .tourn_info_container {
    background-color: #1d2029;
    border-radius: 5px;
    padding: 10px;
  }

  .tourn_info_container p {
    float: right;
    margin-top: -40px;
  }

  #team-btn {
    width: 50%;
    height: 40px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin: 15px auto 0;
    display: block;
    cursor: pointer;
  }

  h4 {
    font-weight: bold;
  }

  #bttnsElement {
    display: none;
    width: 40%;
    height: 40px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin-top: 15px;
    margin-left: 10px;
  }

  #bttnsElement1 {
    display: none;
    width: 40%;
    height: 40px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin-top: -40px;
    margin-left: 315px;
  }

  #formElement {
    display: none;
    width: 340px;
    height: 350px;
    background: #fff;
    padding: 20px;
    margin-left: 100px;
    text-align: center;
    background-color: transparent;
    font-weight: 500;
  }

  .input-box {
    height: auto;
  }

  #btn {
    width: 100%;
    height: 40px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin-top: 15px;
  }

  #team_name {
    display: none;
    width: 340px;
    background: #fff;
    padding: 20px;
    margin-left: 100px;
    text-align: center;
    background-color: transparent;
    font-weight: 500;
  }

  #team_name input {
    border-radius: 5px;
    padding: 10px;
    width: 80%;
    height: 30px;
    border: 1px solid #7d7d7d;
    background: transparent;
  }

  #rTeambttn {
    display: none;
    width: 30%;
    height: 35px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin-left: 190px;
  }

  #createBttn {
    display: none;
  }

  #createBttn button {
    width: 30%;
    height: 35px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin-top: 5px;
    margin-left: 190px;
  }

  /* Leaderboard */

  #leaderboardTable {
    /* display: none; */
  }

  .tournament-results-wrapper {
    margin-left: 350px;
    margin-top: 60px;
    @media only screen and (max-device-width: 1024px) {
      margin-left: 1rem;
    }
  }

  table {
    background: #1d2029;
    border-collapse: collapse;
    width: 60%;
    margin-left: 350px;
    margin-top: 50px;
    margin-bottom: 50px;

    @media only screen and (max-device-width: 1024px) {
      margin-left: 0;
      margin-right: 0;
      width: 95%;
      max-width: 95%;
    }

    tr {
      color: #ccc;
      &.bold {
        color: #73ce08;
        font-weight: bold;
        td {
          font-weight: bold;
        }
      }
    }
  }

  td,
  th {
    border: 1px solid #7d7d7d;
    text-align: left;
    padding: 8px;
    width: 200px;
  }

  th {
    color: #7d7d7d;
  }

  /* live interface */

  h2 {
    margin-left: 220px;
    padding-top: 20px;
  }

  .sidebar h2 {
    margin-left: unset;
  }

  * {
    box-sizing: border-box;
  }

  /* Create two equal columns that floats next to each other */

  .live_column {
    float: left;
    width: 50%;
    padding: 10px;
    height: 500px;
    margin-left: 200px;
    /* margin-top: 30px; */
    /* Should be removed. Only for demonstration */
  }

  .live_show {
    height: 490px;
    width: 100%;
  }

  .chat_column {
    float: left;
    width: 34%;
    padding: 10px;
    height: 490px;
    margin-top: 9px;
    overflow: auto;
  }

  /* Clear floats after the columns */

  .row:after {
    content: "";
    display: table;
    clear: both;
  }

  /* Live Chat */

  #liveSection {
    /* display: none; */
    margin-top: 20px;
  }

  .chat_container {
    border: 2px solid #dedede;
    background-color: #1d2029;
    border-radius: 5px;
    padding: 10px;
    margin: 10px 0;

    p {
      margin: 0;
      padding: 0;
    }
  }

  .chat_container::after {
    content: "";
    clear: both;
    display: table;
  }

  .chat_container img {
    float: left;
    max-width: 30px;
    width: 100%;
    margin-right: 20px;
    border-radius: 80%;
  }

  .chat_container img.right {
    float: right;
    margin-left: 20px;
    margin-right: 0;
  }

  .time-right {
    float: right;
    color: #aaa;
  }

  .chat_input {
    border: 2px solid #aaa;
    background-color: #1d2029;
    border-radius: 5px;
    padding: 10px;
    margin: 10px 0;
  }

  .chat_input::after {
    content: "";
    clear: both;
    display: table;
  }

  .chat_input img {
    float: left;
    max-width: 30px;
    width: 100%;
    margin-right: 20px;
    border-radius: 80%;
    margin-top: 10px;
  }

  .chat_input img.right {
    float: right;
    margin-left: 20px;
    margin-right: 0;
  }

  .chat_input input {
    border-radius: 7px;
    color: #fff;
    padding: 10px;
    margin: 10px 10px 10px 0;
    width: 70%;
    height: 35px;
    border: 1px solid #7d7d7d;
    background: transparent;
  }

  .chat_input button {
    cursor: pointer;
    display: "inline-block";
  }
  @media (max-width: 858px) {
    /* Side Bar */
    .sidebar {
      width: 0%;
      height: 0%;
    }
    .search {
      display: none;
    }
    .side-logo {
      width: 50px;
      height: 50px;
      margin-top: -27px !important;
      margin-left: 5px;
    }
    .checkbtn {
      background-color: #1d2029;
      width: 70px;
      height: 60px !important;
      display: block;
      float: right;
      margin-right: 0px;
      margin-top: 0px !important;
    }
    .checkbtn i {
      padding-left: 20px;
      padding-right: 20px;
    }
    .sidebar ul {
      position: fixed;
      width: 100%;
      height: 100%;
      background: #701129;
      top: 70px;
      top: -100%;
      text-align: center;
      transition: all 0.5s;
      display: none;
    }

    #check:checked ~ .sidebar ul {
      top: 60px;
    }
    /* Top Navbar */
    .main_content {
      width: 100%;
      margin-left: 0px;
    }
    /* Game Info */
    .profile_cover_photo {
      width: 818px;
      margin-left: -200px;
      margin-top: -20px;
    }
    .game_info_pic img {
      top: 90px;
      left: 30px;
      width: 130px;
      height: 190px;
    }
    .ph1 {
      margin-left: -20px;
      font-size: 30px;
    }
    /* Floating Navbar */
    .tourn_float_navbar {
      margin-left: 170px;
      margin-right: 30px;
      margin-top: -130px;
    }
    /* Info Section */
    .tourn_column {
      width: 60%;
      height: 500px;
      margin-left: 20px;
    }
    .tourn_info_column {
      width: 35%;
      margin-right: 20px;
      margin-top: -520px;
    }
    .tourn_info_container h3 {
      font-size: 13px;
    }
    .tourn_info_container p {
      margin-top: -15px;
      font-size: 12px;
    }
    .reg_icon p {
      margin-left: -260px;
      font-size: 15px;
    }
    .trophy_icon p {
      margin-left: 220px;
    }
    .phases3 {
      margin-top: 20px;
      margin-left: 130px;
    }
    .close_icon img {
      margin-left: 180px;
    }
    .close_icon p {
      margin-left: -15px;
    }
    #team-btn {
      margin-left: 100px;
    }
  }

  @media (max-width: 440px) {
    /* Game Info */
    .profile_cover_photo {
      width: 440px;
    }
    .game_info_pic img {
      top: 70px;
      left: 10px;
      left: 1.5rem;
      width: 90px;
      height: 120px;
    }
    .ph1 {
      margin-left: -77px;
      font-size: 18px;
      margin-top: -28px;
      margin-top: 1.5rem;
    }
    /* Floating Navbar */
    .tourn_float_navbar {
      margin-left: 20px;
      margin-right: 20px;
      // margin-top: -180px;
      margin-left: 2.5%;
      margin-right: 2.5%;
    }
    /* Info Section */
    .tourn_column {
      width: 400px;
      margin: auto;
      height: fit-content;
      width: 100%;
    }
    .tourn_info_column {
      width: 400px;
      margin-top: 100px;
      width: 100%;
      margin-top: 1.5rem;
      margin-right: 0;
      height: unset;
      margin: 0;
    }
    .phases {
      width: 170px;
    }
    .reg_icon img {
      width: 70px;
      height: auto;
    }
    .reg_icon p {
      margin-left: -200px;
    }
    .phases2 {
      width: 170px;
      margin-left: 200px;
      margin-top: -150px;
    }
    .trophy_icon img {
      width: 70px;
      height: auto;
      margin-left: 250px;
      margin-top: 16px;
    }
    .trophy_icon p {
      margin-left: 190px;
      font-size: 14px;
    }
    .phases3 {
      margin-left: 100px;
    }
    .close_icon img {
      margin-left: 150px;
    }
    #team-btn {
      margin-left: 90px;
    }
    #bttnsElement1 {
      margin-left: 215px;
    }
    #formElement {
      margin-left: -10px;
    }
  }
`;
